import React, {useState, useEffect}  from 'react';
import SectionHeader from './sectionHeader.js'
import {_getCoutryGoogleChartName} from '../helpers/helpers.js'

import {TechnologyGeoData, RtHeader} from '../../../server/routes/route-types.js'

interface GeoData {
	Header: RtHeader;
	Countries: TechnologyGeoData[];
}

interface GoogleVisualization {
	visualization: {
		arrayToDataTable: (data: wts_approved_any[][]) => wts_approved_any;
		GeoChart: new (element: HTMLElement) => {
			draw: (data: wts_approved_any, options: wts_approved_any) => void;
		};
	};
	charts: {
		load: (version: string, options: { packages: string[] }) => void;
		setOnLoadCallback: (callback: () => void) => void;
	};
}

// declare global {
// 	interface Window {
// 		google: GoogleVisualization;
// 		initMap?: () => void;
// 	}
// }

interface GeoDistributionProps {
	geoData?: GeoData;
//	google?: GoogleVisualization;
	google?: wts_approved_any;
	link?: string;
}

export default function GeoDistribution({geoData, google, link}: GeoDistributionProps) {
	// DMK: June 3, 24
	// temporary disabled geocharts to investigate page load slowness
	return (<></>);

// 	if (!google) return null;
// 	if (!geoData) return (<></>);
// 	if (!geoData.Countries) return (<></>);
// 	if (!geoData.Countries.length) return (<></>);

// 	const [chart, setChart] = useState<wts_approved_any>(false);
// 	const [maps, setMaps] = useState<boolean>(false);

// 	useEffect(() => { 

// 		if (!maps)
// 		{
// //			console.log('GeoDistribution no maps');

// 			const head = document.head;
		
// 			let script = document.getElementById('googleMapScript') as HTMLScriptElement | null;
// 			if (!script) {
				
// //				console.log('GeoDistribution no script');
			
// 				script = document.createElement('script') as HTMLScriptElement;
									
// 				script.src = 'https://maps.googleapis.com/maps/api/js?loading=async&callback=initMap';
// 				script.async = true;
// 				script.defer = true;
// 				script.id = 'googleMapScript';
			
// 				window.initMap = function() {
// //					console.log('GeoDistribution initMap callback');				
// 					setMaps(true);	

// 					window.google.charts.load('current', {packages: ['geochart']});
// 					window.google.charts.setOnLoadCallback(drawChart);					
// //					console.log('GeoDistribution initMap exit');				
// 				}
// 				// --
// 				head.appendChild(script);
// //				console.log('GeoDistribution appendChild script');				
// 			} 
// 			else
// 			{
// 				// why are we here
// //				console.log('googleMapScript already exists');
// 				window.google.charts.load('current', {packages: ['geochart']});
// 				window.google.charts.setOnLoadCallback(drawChart);	
// 				setMaps(true);	
// 			}
// 		}
		
// 		function drawChart(): void {

// //			console.log('drawChart enter');				

// 			let propsData: wts_approved_any[][] = [['Country', 'Domains']];
// 			geoData.Countries.forEach(country => {
// 				propsData.push([
// 					_getCoutryGoogleChartName(country.Country), 
// 					country.DomainCount
// 				])
// 			})

// 			var data = google.visualization.arrayToDataTable(propsData);
// 			var options = {
// 				colorAxis: {
// 					colors: ['#3d8592', '#023741']
// 				}
// 			};
// 			const newChart = new google.visualization.GeoChart(document.getElementById('regions_div') as HTMLElement);
// 			newChart.draw(data, options);
	
// //			console.log('drawChart exit');				
// 			setChart(newChart);	
// 		}	

// 	}, [chart, maps]);

// 	return (<>
// 		<div className="row row-50">
// 			<div className = "col-12">
// 				<SectionHeader header={geoData.Header} link={link} anchor='geo'/>
// 				<div 
// 					id="regions_div" 
// 					style={{width: '90%'}}
// 				>
// 				</div>
// 			</div>
// 		</div>
// 		<br/>
// 	</>)
}
